import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Chip } from '@material-ui/core';
import moment from 'moment';

import CabeceroReportes from '../../componentes/CabeceroReportes';
import Default from '../../contenedores/Default';
import ListaConfiguracion from '../../componentes/ListaConfiguracion';
import Tabla from '../../componentes/Table';

import { useFetchReporte } from '../../hooks/useFetchReporte';

import endpoints, { FENOLOGIAS, TABLAS } from '../../configuraciones/endpoints';
import paleta from '../../configuraciones/paleta';

import { DatePickerTypes } from '../../constantes/datePickerTypes';

const estados = {
  Vegetativo: paleta.configuraciones.vegetativo,
  Generativo: paleta.configuraciones.generativo,
  Balanceado: paleta.configuraciones.balanceado,
};

const cabeceros = [
  { label: 'Sitio', key: 'sitio', align: 'left' },
  { label: 'Invernadero', key: 'invernadero', align: 'left' },
  { label: 'Nave', key: 'nave', align: 'left' },
  { label: 'Tabla', key: 'tabla', align: 'left' },
  { label: 'Planta', key: 'planta', align: 'left' },
  { label: 'Cultivo', key: 'cultivo', align: 'left' },
  { label: 'Fenología', key: 'fenologia', align: 'left' },
  { label: 'Registro', key: 'registro', align: 'left' },
  {
    label: 'Estado',
    align: 'center',
    transform: (data) => {
      if (!data) return null;
      return (
        <Chip
          style={{
            backgroundColor: estados[data.estado] || 'transparent',
            color: estados[data.estado] ? '#FFFF' : '#000',
            width: 100,
            height: 25,
            fontWeight: '800',
          }}
          label={data.estado?.toString().toUpperCase()}
          size="small"
        />
      );
    },
  },
];

const datosLista = {
  labelProp: 'nombre',
  headerLista: 'Nombre',
  title: 'Reporte de Fenologías',
  data: [
    {
      id: 0,
      nombre: 'Registros por promedio',
      subTitle: 'Listado de fenologías promediadas.',
    },
    {
      id: 1,
      nombre: 'Registros por planta',
      subTitle: 'Listado de capturas por planta.',
    },
  ],
};

const ReportesFenologiasPlantas = ({ history }) => {
  const { registros } = useSelector((store) => store.listados);
  const { data, formData, buscar, onChange, onDelete } = useFetchReporte(
    {
      tablas: endpoints.base.busqueda(TABLAS),
      fenologias: endpoints.base.busqueda(FENOLOGIAS),
      plantas: ([_sitios, _invernaderos, _naves, tablas]) =>
        tablas.map(({ plantas = [] }) => plantas).flat(),
    },
    endpoints.reporteFenologiasPlantas(),
  );

  const onSubMenuClick = (id) => {
    if (id === 1) {
      history.push(`/reportes/fenologiasplanta`);
    } else {
      history.push(`/reportes/fenologiaspromedio`);
    }
  };

  const handleTodosSelected = useCallback(() => {
    const { sitios, invernaderos, naves, tablas, plantas, fenologias } =
      formData;

    const params = {
      sitios,
      invernaderos,
      naves,
      tablas,
      plantas,
      fenologias,
      fecha: moment(formData.fecha).format('W-GGGG'),
    };
    return params;
  }, [formData]);

  return (
    <Default
      mostrarLista={
        <ListaConfiguracion
          datosLista={datosLista}
          onClick={onSubMenuClick}
          initOpcion={1}
        />
      }
    >
      <CabeceroReportes
        data={data}
        formData={formData}
        buscar={buscar}
        onChange={onChange}
        onDelete={onDelete}
        handleTodosSelected={handleTodosSelected}
        selects={{
          sitio: { width: 3, show: true },
          invernadero: { width: 3, show: true },
          nave: { width: 3, show: true },
          tabla: { width: 3, show: true },
          fenologia: { width: 3, show: true },
          planta: { width: 3, show: true },
          fecha: { width: 3, show: true, type: DatePickerTypes.week },
        }}
        endpoint={endpoints.reporteFenologiasPlantas()}
        method="POST"
      />
      <Tabla
        headers={cabeceros}
        rows={registros.rows.length > 0 ? registros.rows : []}
        count={registros.count}
        showActions={false}
      />
    </Default>
  );
};

export default ReportesFenologiasPlantas;
